// API
export const API_DEBOUNCE_TIMEOUT = 4000;
export const API_POST_TIMEOUT = 0; // TODO: for development only
export const SIGNED_URL_EXPIRED_TIME = 60 * 24; // minutes
export const MAX_NUMBER_OF_CHARACTERS = 255;

// wavesurfer
export const WS_INACCURACY = 0.05;
export const MIN_CELL_DUR = 0.1;
export const MIN_CURSOR_MOVE_THRESHOLD_PX = 50;
export const MIN_REGION_DUR = 100;

// selector
export const MIN_CLIP_WIDTH = 100;
export const CLIP_ASPECT_RATIO = 9 / 15;

//effects
export const EFFECT_VALUE_MIN = -100;
export const EFFECT_VALUE_MIN_ZERO = 0;
export const EFFECT_VALUE_MAX = 100;
export const EFFECT_VALUE_CSS_OFFSET = 100;
export const EFFECT_DEFAULT_VALUE = (EFFECT_VALUE_MAX + EFFECT_VALUE_MIN) / 2;
export const HIGHLIGHT_SENSITIVITY_DEFAULT = 50;

// SB player
export const NUMBER_OF_PLAYERS = 4;
export const NUMBER_OF_PREV_PLAYERS = 1; // there should be at least one because of the transition effect between clips
export const PLAYBACK_RATE_DEFAULT = 1;
export const PLAYBACK_RATE_MIN = 0.0625;
export const PLAYBACK_RATE_MAX = 12.0;
export const MIN_FADE_IN = 0;
export const MIN_FADE_OUT = 0;

// thumbnails
export const THUMBNAIL_QUALITY = 0.33;
export const THUMBNAIL_MAX_WIDTH = 400;
export const THUMBNAIL_RATIO = 9 / 6;

// other
export const INACCURACY = 1 / Math.pow(10, 6);
export const FILE_QUALITY: 'low' | 'medium' | 'high' = 'low';
export const FREE_STORAGE_LIMIT = 10;
export const TOOLTIP_DELAY = 400; // ms
